export const shouldShowPreviousArrow = ({
  currentSlide = 0,
  slider
}) => {
  const {
    loop
  } = slider ?? {};
  if (loop === undefined || loop === false) {
    return currentSlide !== 0;
  }
  if (loop === true) {
    return true;
  }
  return loop.min === undefined || currentSlide > loop.min;
};
//# sourceMappingURL=shouldShowPreviousArrow.js.map